import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.scss';
import { LocaleProvider } from 'antd';
import esES from 'antd/lib/locale-provider/es_ES';
import enUS from 'antd/lib/locale-provider/en_US';

console.log(navigator.language);

ReactDOM.render(
  <LocaleProvider locale={navigator.language === 'en-US' ? enUS : esES}>  
    <App />
  </LocaleProvider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx